document.addEventListener("DOMContentLoaded", function () {

  function updateTitles() {
    // Detect selected purchase type
    let selectedType = document.querySelector(".kaching-bundles__subscriptions .kaching-bundles__bar--selected .kaching-bundles__subscriptions__title");

    if (!selectedType) return;

    let isOTP = selectedType.innerText.includes("One-time purchase");

    document.querySelectorAll(".kaching-bundles__bar-title").forEach((el) => {
      let original = el.getAttribute("data-original") || el.innerText;

      // Save original text once
      if (!el.getAttribute("data-original")) {
        el.setAttribute("data-original", original);
      }

      if (isOTP) {
        // OTP Mode → Change to simple Buy 1 / Buy 2
        if (original.includes("Buy 1")) el.innerText = "Buy 1";
        if (original.includes("Buy 2")) el.innerText = "Buy 2";
      } else {
        // Subscription Mode → Revert
        el.innerText = original;
      }
    });
  }

  // When user clicks a Kaching bar → update instantly
  document.addEventListener("click", function (e) {
    if (e.target.closest(".kaching-bundles__bar")) {
      setTimeout(updateTitles, 0);  // ← instant change
    }
  });

  // Run once when widget loads
  setTimeout(updateTitles, 800);
});
